import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import globalStyles from "../../../global";

// Custom Arrow Components
const CustomPrevArrow = ({ onClick, isRTL }) => (
  <Box
    onClick={onClick}
    sx={{
      position: "absolute",
      top: "50%",
      left: isRTL ? "auto" : "20px",
      right: isRTL ? "20px" : "auto",
      transform: "translateY(-50%)",
      zIndex: 2,
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: globalStyles.colors.army_green,
        color: "white",
        transform: "translateY(-50%) scale(1.1)",
      },
    }}
  >
    {isRTL ? <ArrowForwardIos /> : <ArrowBackIos />}
  </Box>
);

const CustomNextArrow = ({ onClick, isRTL }) => (
  <Box
    onClick={onClick}
    sx={{
      position: "absolute",
      top: "50%",
      right: isRTL ? "auto" : "20px",
      left: isRTL ? "20px" : "auto",
      transform: "translateY(-50%)",
      zIndex: 2,
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: globalStyles.colors.army_green,
        color: "white",
        transform: "translateY(-50%) scale(1.1)",
      },
    }}
  >
    {isRTL ? <ArrowBackIos /> : <ArrowForwardIos />}
  </Box>
);

// Success Stories Data (from the Excel mapping)
const successStories = [
  {
    image: "PR Images-01.jpg",
    link: "https://www.financialexpress.com/business/industry-uclean-a-laundromat-in-your-neighbourhood-799827/",
    headline: "UClean: A laundromat in your neighbourhood",
    summary: `For time-crunched urban Indians, grocery shopping and utility bill payments have moved online but they still have to spare at least an hour for laundry or other household chores. In January, tech-enabled laundry service UClean entered the market to lead the online shift in laundry services. It is focused on...`,
    alt: "Digital Transformation",
  },
  {
    image: "PR Images-02.jpg",
    link: "https://www.thehindubusinessline.com/companies/startup-uclean-hopes-to-bring-laundromat-culture-to-india/article9485547.ece",
    headline: "Start-up UClean hopes to bring laundromat culture to India",
    summary: `Tech-enabled laundry services start-up UClean is hoping to usher in the ‘do-it-yourself’ (DIY) laundromat culture to the country. The company has roped in celebrity couple Soha Ali Khan and Kunal Khemu as strategic partners and brand ambassadors to promote the concept.`,
    alt: "Global Expansion",
  },
  {
    image: "PR Images-03.jpg",
    link: "https://economictimes.indiatimes.com/wealth/earn/how-startup-uclean-is-making-money-by-washing-your-dirty-laundry/articleshow/63144767.cms?from=mdr",
    headline:
      "How startup UClean is making money by washing your dirty laundry",
    summary: `UClean has set up brick and mortar stores, equipped with the laundromachines and ironing setup, which cater to the laundry needs of customers in the store's neighbourhood.`,
    alt: "Innovation Award",
  },
  // PR 04 is missing in the sheet, so skipping PR Images-04.jpg
  {
    image: "PR Images-05.jpg",
    link: "https://www.techcircle.in/2019/08/14/tech-enabled-laundromat-chain-uclean-acquires-white-tiger",
    headline: "Tech-enabled laundromat chain UClean acquires White Tiger",
    summary: `Faridabad-based tech-enabled laundromat chain UClean has acquired Delhi NCR-based peer White Tiger. The acquisition involved the purchase of White Tiger’s 20 outlets in Delhi NCR region, UConcepts Solutions, which operates UClean, said in a statement. The terms of the deal haven’t been disclosed...`,
    alt: "Sustainability",
  },
  {
    image: "PR Images-06.jpg",
    link: "https://www.livemint.com/companies/start-ups/laundry-startup-uclean-tastes-success-with-franchise-format-1565892168589.html",
    headline: "Laundry startup UClean tastes success with franchise format",
    summary: `In just over three years, the firm has expanded to 175 franchisees closing an annual GMV of ₹30 crore. Sinha operates on a business model where the franchise owner invests his or her own money, and manages their own stores.`,
    alt: "Customer Success",
  },
  {
    image: "PR Images-07.jpg",
    link: "https://thebetterindia.com/323629/arunabh-sinha-gujan-taneja-started-uclean-laundromat-iron-dhobi-washing-service/",
    headline:
      "Laundromats in India? Couple Built Rs 100 Crore Biz Washing Dirty Linen Across 100 Cities",
    summary: `Faridabad’s Arunabh Sinha and his wife Gujan Taneja launched UClean in 2017 to set up an organised laundromat service in India. Currently, they are spread across 100+ cities and have 350+ outlets across the country.`,
    alt: "Team Excellence",
  },
  // PR Images-09.jpg
  {
    image: "PR Images-09.jpg",
    link: "https://yourstory.com/ys-gulf/laundromat-chain-uclean-plans-to-open-over-75-outlets-in-mena-saarc-region",
    headline:
      "LAUNDROMAT CHAIN UCLEAN PLANS TO OPEN OVER 75 OUTLETS IN MENA, SAARC REGION",
    summary: `Laundromat chain UClean said it is expanding its global presence by opening 25 stores in the South Asian Association for Regional Cooperation (SAARC) and 50 stores in the Middle East and North Africa (MENA) regions.`,
    alt: "Innovation",
  },
  // PR Images-10.jpg
  {
    image: "PR Images-10.jpg",
    link: "https://yourstory.com/ys-gulf/laundromat-chain-uclean-plans-to-open-over-75-outlets-in-mena-saarc-region",
    headline:
      "LAUNDROMAT CHAIN UCLEAN PLANS TO OPEN OVER 75 OUTLETS IN MENA, SAARC REGION",
    summary: `Laundromat chain UClean said it is expanding its global presence by opening 25 stores in the South Asian Association for Regional Cooperation (SAARC) and 50 stores in the Middle East and North Africa (MENA) regions.`,
    alt: "Growth",
  },
  // Images 12 is not mapped, so fallback to original content
];

const SuccessStory = ({ countryCode = "uae" }) => {
  const { t, i18n } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const isRTL = i18n.language === "ar";
  const [currentSlide, setCurrentSlide] = useState(0);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    rtl: isRTL,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    prevArrow: <CustomPrevArrow isRTL={isRTL} />,
    nextArrow: <CustomNextArrow isRTL={isRTL} />,
    appendDots: (dots) => (
      <Box sx={styles.dotsContainer}>
        <Box
          component="ul"
          sx={{ m: 0, p: 0, listStyle: "none", display: "flex" }}
        >
          {dots}
        </Box>
      </Box>
    ),
    customPaging: (i) => (
      <Box
        sx={{
          ...styles.dot,
          backgroundColor:
            i === currentSlide
              ? globalStyles.colors.army_green
              : globalStyles.colors.light_gray2,
        }}
      />
    ),
  };

  const styles = {
    mainContainer: {
      width: "100%",
      overflow: "hidden",
      direction: isRTL ? "rtl" : "ltr",
      backgroundColor: "#f8f9fa",
    },
    contentWrapper: {
      maxWidth: "1200px",
      mx: "auto",
      width: "100%",
      px: { xs: 2, md: 0 },
      py: { xs: 4, md: 10 },
    },
    headerSection: {
      marginBottom: "40px",
    },
    heading: {
      color: globalStyles.colors.head_green,
      fontSize: {
        md: "40px",
        sm: "28px",
        xs: "24px",
      },
      fontWeight: 600,
      textAlign: isRTL ? "right" : "left",
    },
    subheading: {
      color: globalStyles.colors.medium_gray,
      fontSize: {
        sm: "20px",
        xs: "16px",
      },
      fontFamily: globalStyles.fonts.primary,
      lineHeight: 1.6,
      marginBottom: "24px",
      textAlign: isRTL ? "right" : "left",
      my: 2,
    },
    sliderContainer: {
      width: "100%",
      position: "relative",
      backgroundColor: "white",
      borderRadius: "16px",
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
      overflow: "hidden",
      maxWidth: "1000px",
      mx: "auto",
    },
    slideItem: {
      position: "relative",
      outline: "none",
    },
    slideImage: {
      objectFit: "contain",
      display: "block",
    },
    contentSection: {
      py: 2,
      px: 4,
    },
    descriptionRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      flexWrap: "wrap",
    },
    description: {
      color: "#4d4d4d",
      fontSize: {
        md: "26px",
        sm: "22px",
        xs: "20px",
      },
      fontWeight: 600,
      fontFamily: globalStyles.fonts.primary,
      textAlign: isRTL ? "right" : "left",
      flex: "1 1 auto",
    },
    details: {
      color: globalStyles.colors.text,
      fontSize: {
        sm: "20px",
        xs: "16px",
      },
      fontFamily: globalStyles.fonts.primary,
      lineHeight: "auto",
      textAlign: isRTL ? "right" : "left",
    },
    button: {
      color: globalStyles.colors.uclean_green,
      border: `1px solid ${globalStyles.colors.uclean_green}`,
      px: 4,
      py: 1,
      fontFamily: globalStyles.fonts.primary,
      fontWeight: 500,
      textWrap: "nowrap",
      textTransform: "none",
      "&:hover": {
        backgroundColor: globalStyles.colors.army_green,
        color: globalStyles.colors.white,
      },
    },
    dotsContainer: {
      position: "absolute",
      bottom: "20px",
      left: 0,
      right: 0,
      display: "flex",
      justifyContent: "center",
      padding: 0,
      margin: 0,
      zIndex: 3,
    },
    dot: {
      width: "14px",
      height: "14px",
      borderRadius: "50%",
      cursor: "pointer",
      margin: "0 6px",
      transition: "all 0.3s ease",
      border: "2px solid white",
      "&:hover": {
        transform: "scale(1.2)",
      },
    },
  };

  return (
    <Box sx={styles.mainContainer}>
      <Box sx={styles.contentWrapper}>
        <Box sx={styles.headerSection}>
          <Typography variant="h1_gothic" sx={styles.heading}>
            {t("successStorySr.heading") || "Our Success Stories"}
          </Typography>
          <Typography sx={styles.subheading}>
            {t("successStorySr.subheading") ||
              "Discover how we've helped organizations achieve remarkable results through innovation and excellence."} check  
          </Typography>
        </Box>

        <Box sx={styles.sliderContainer}>
          <Slider {...sliderSettings}>
            {successStories.map((story, index) => (
              <Box key={index} sx={styles.slideItem}>
                <Box
                  component="img"
                  src={`${imageBaseUrl}${story.image}`}
                  alt={story.alt}
                  sx={styles.slideImage}
                />
                <Box sx={styles.contentSection}>
                  <Box
                    sx={{
                      display: { sm: "flex", xs: "block" },
                      justifyContent: "space-between",
                      alignItems: "start",
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <Typography sx={styles.description}>
                      {story.headline}
                    </Typography>
                    {story.link && (
                      <Button
                        sx={{
                          ...styles.button,
                          width: { xs: "100%", md: "auto" }, // Full width on mobile, auto on desktop
                          mt: { xs: 2, md: 0 }, // Margin-top on mobile
                          // alignSelf: { xs: "stretch", md: "flex-start" }, // Stretch full width on mobile
                        }}
                        component="a"
                        href={story.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Read Full Story
                      </Button>
                    )}
                  </Box>
                  <Typography sx={styles.details}>{story.summary}</Typography>
                </Box>
              </Box>
            ))}
          </Slider>
        </Box>
      </Box>
    </Box>
  );
};

export default SuccessStory;
